import { config } from '../config';

export const fetchB2BMarIaChatAnswer = (messagesDTO, accessToken, setAnswer, setIsGeneratingAnswer) => {
    const url = `${config.baseB2B_URL}/b2b/maria/chat`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
    setIsGeneratingAnswer(true);
    fetch(url, {
        method: 'POST',
        headers: {
            ...headers,
        },
        body: JSON.stringify(messagesDTO.messages),
    })
        .then(response => {
            const reader = response.body.getReader();
            let decoder = new TextDecoder();
            let dataBuffer = '';
            return new ReadableStream({
                start(controller) {
                    function push() {
                        reader.read().then(({ done, value }) => {
                            if (done) {
                                if (dataBuffer.trim()) {
                                    try {
                                        let json = JSON.parse(dataBuffer);
                                        setAnswer(prevAnswer => prevAnswer + json.message.content);
                                    } catch (e) {
                                        console.error('Failed to parse JSON', e);
                                    }
                                }
                                controller.close();
                                setIsGeneratingAnswer(false);
                                return;
                            }
                            const chunk = decoder.decode(value, { stream: true });
                            dataBuffer += chunk;
                            let lines = dataBuffer.split('\n');
                            for (let i = 0; i < lines.length - 1; i++) {
                                try {
                                    let json = JSON.parse(lines[i]);
                                    setAnswer(prevAnswer => prevAnswer + json.message.content);
                                } catch (e) {
                                    console.error('Failed to parse JSON', e);
                                }
                            }
                            dataBuffer = lines[lines.length - 1];
                            push();
                        });
                    }
                    push();
                }
            });
        })
        .then(stream => new Response(stream))
        .then(response => response.text())
        .then(data => {
            console.log(data);
            setIsGeneratingAnswer(false);
        })
        .catch((error) => {
            console.error('Failed to fetch Mar·Ia answer:', error);
            setIsGeneratingAnswer(false);
        });
}

export const fetchB2BMarIaGenerateAnswer = (question, accessToken, setAnswer, setIsGeneratingAnswer) => {
    const url = `${config.baseB2B_URL}/b2b/maria/generate`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'text/plain',
    };

    // Initialize isGeneratingAnswer to true
    setIsGeneratingAnswer(true);

    fetch(url, {
        method: 'POST',
        headers: {
            ...headers,
        },
        body: question,
    })
        .then(response => {
            const reader = response.body.getReader();
            let decoder = new TextDecoder();
            let dataBuffer = '';

            return new ReadableStream({
                start(controller) {
                    function push() {
                        reader.read().then(({ done, value }) => {
                            if (done) {
                                // Process any remaining dataBuffer
                                if (dataBuffer.trim()) {
                                    try {
                                        let json = JSON.parse(dataBuffer);
                                        //console.log(json);
                                        setAnswer(prevAnswer => prevAnswer + json.response);
                                    } catch (e) {
                                        console.error('Failed to parse JSON', e);
                                    }
                                }
                                controller.close();
                                //console.log('Stream complete');
                                // Set isGeneratingAnswer to false when done
                                setIsGeneratingAnswer(false);
                                return;
                            }
                            const chunk = decoder.decode(value, { stream: true });
                            dataBuffer += chunk;

                            // Split by new line and process each JSON object
                            let lines = dataBuffer.split('\n');
                            for (let i = 0; i < lines.length - 1; i++) {
                                try {
                                    let json = JSON.parse(lines[i]);
                                    setAnswer(prevAnswer => prevAnswer + json.response);
                                } catch (e) {
                                    console.error('Failed to parse JSON', e);
                                }
                            }
                            // Keep the last incomplete part
                            dataBuffer = lines[lines.length - 1];
                            push();
                        });
                    }
                    push();
                }
            });
        })
        .then(stream => new Response(stream))
        .then(response => response.text())
        .then(data => {
            console.log(data);
            // This might be redundant if the stream has already set it to false
            setIsGeneratingAnswer(false);
        })
        .catch((error) => {
            console.error('Failed to fetch Mar·Ia answer:', error);
            // Set isGeneratingAnswer to false in case of error
            setIsGeneratingAnswer(false);
        });
}
